import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BellAlertIcon } from '@heroicons/react/24/outline';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const AlertRecipients = () => {
  const [recipients, setRecipients] = useState([]);
  const [newPhone, setNewPhone] = useState('');

  const fetchRecipients = async () => {
    try {
      const response = await axios.get(`${API_URL}/alerts`);
      setRecipients(response.data);
    } catch (err) {
      console.error('Erro ao carregar alert recipients:', err);
    }
  };

  const addRecipient = async () => {
    if (!newPhone.trim()) return;
    try {
      await axios.post(`${API_URL}/alerts`, { phone: newPhone.trim() });
      setNewPhone('');
      fetchRecipients();
    } catch (err) {
      console.error('Erro ao adicionar número:', err);
    }
  };

  const deleteRecipient = async (id) => {
    try {
      await axios.delete(`${API_URL}/alerts/${id}`);
      fetchRecipients();
    } catch (err) {
      console.error('Erro ao deletar número:', err);
    }
  };

  useEffect(() => {
    fetchRecipients();
  }, []);

  // --- Informational Banner (always top) ---
  const InfoBanner = () => (
    <div className="mb-6 rounded-xl border border-blue-200 bg-blue-50 px-4 py-5">
      <div className="flex items-start gap-3">
        <BellAlertIcon className="h-6 w-6 text-blue-600 flex-shrink-0" />
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Alert Recipients</h2>
          <p className="mt-1 text-gray-700 text-sm">
            Manage the phone numbers that will receive real-time alerts when messages
            are classified as <em>urgent</em> or moved to <strong>Awaiting Human</strong>.
            Use the E.164 format (e.g., +12075550123). Removing a number stops future alerts only.
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="p-6">
      {/* Banner no topo */}
      <InfoBanner />

      <div className="mb-6 flex gap-4">
        <input
          type="text"
          placeholder="Enter phone (e.g. +12075550123)"
          value={newPhone}
          onChange={(e) => setNewPhone(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 w-64"
        />
        <button
          onClick={addRecipient}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Add
        </button>
      </div>

      <table className="w-full bg-white shadow-md rounded">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-3">Phone</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {recipients.map((r) => (
            <tr key={r._id} className="border-t">
              <td className="p-3">{r.phone}</td>
              <td className="p-3">
                <button
                  onClick={() => deleteRecipient(r._id)}
                  className="text-red-500 hover:underline"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {recipients.length === 0 && (
            <tr>
              <td className="p-3 text-gray-500" colSpan={2}>
                No alert numbers found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AlertRecipients;
